import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import html2canvas from 'html2canvas';
import { AuthService } from '../auth/auth.service';
import { RequestedSearch } from '../models/requested-payments';
import { NzTableData } from '../utilities/nz-table.adapter';
import * as urls from '../utilities/urls';
import jspdf from 'jspdf';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(private httpClient: HttpClient,private authService: AuthService ) { }
  merchantLocationInitialize(value){
    return this.httpClient.post(urls.PaymentUrls.generateLink,value)
  }
  sentpaymentLink(value){
    
    return this.httpClient.post(urls.PaymentUrls.paymentLink,value)
  }
 
getRequestedPaymentslist(tableData: NzTableData<RequestedSearch, any>){
  const value = {
    merchantId: this.authService.getMerchantId(),
    paymentMethod:tableData.search.paymentMethod ? tableData.search.paymentMethod : '',
    locationId: tableData.search.locationId ? tableData.search.locationId : '',
    paymentId:tableData.search.paymentId?tableData.search.paymentId:'',
    startDate: tableData.search.createdDate.startDate ? tableData.search.createdDate.startDate : '',
    endDate: tableData.search.createdDate.endDate ? tableData.search.createdDate.endDate : '',
    status: tableData.search.status,
    expiryTime:tableData.search.status,
    pageSize: tableData.pageSize,
    pageIndex: tableData.pageIndex
};
  return this.httpClient.post(urls.PaymentUrls.requestedPayment, value);
}
 // For all requested payment
 clearSearchFields(tableData: NzTableData<RequestedSearch, any>, value) {
  if (value === 'paymentId') {
  return tableData.search.paymentId = '';
  }
  if (value === 'startDate') {
    return tableData.search.startDate = '';
}
if (value === 'endDate') {
    return tableData.search.endDate = '';
}
}
downloadRequestedPaymentReport(value) {
  return this.httpClient.post(urls.PaymentUrls.requestedPayment, value);
}
//Download QRCode Image
getPdfForQRCode(id){
  const fileName = 'QR Code for Payment Link';
  const data = document.getElementById(id)
;
  html2canvas((data), { scale: 2 }).then(canvas => {

// Few necessary setting options

const pdf = new jspdf('p', 'px', 'a4'); // A4 size page of PDF
const imgWidth = pdf.internal.pageSize.getWidth();
const pageHeight = 295;
const imgHeight = pdf.internal.pageSize.getHeight();
const heightLeft = imgHeight;

const contentDataURL = canvas.toDataURL('image/jpeg');
const position = 0;
pdf.addImage(contentDataURL, 'JPEG', 0, position, imgWidth, imgHeight);
pdf.save(fileName); // Generated PDF

});
}
}
